/* src/app/components/user/manage-password/manage-password.component.scss */
.password {
  margin-top: 10px;
  margin-bottom: 5px;
}
/*# sourceMappingURL=manage-password.component.css.map */
